import { render } from "./WildBookFallAnimalExtension.vue?vue&type=template&id=320af9d4&scoped=true&ts=true"
import script from "./WildBookFallAnimalExtension.vue?vue&type=script&lang=ts"
export * from "./WildBookFallAnimalExtension.vue?vue&type=script&lang=ts"

import "./WildBookFallAnimalExtension.vue?vue&type=style&index=0&id=320af9d4&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320af9d4"]])

export default __exports__